import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '6px',
    marginBottom: '6px'
  }
}));

const OptionsDropdown = ({
  children,
  expanded,
  onCollapse,
  anchorEl,
  placement = "bottom-end"
}) => {
  const classes = useStyles();
  return React.createElement(Popper, {
    open: expanded,
    style: {
      zIndex: 2000
    },
    role: undefined,
    transition: true,
    anchorEl: anchorEl,
    placement: placement
  }, React.createElement(ClickAwayListener, {
    onClickAway: onCollapse
  }, React.createElement(Paper, {
    elevation: 16,
    square: true,
    className: classes.root,
    "aria-expanded": expanded
  }, children)));
};

export default OptionsDropdown;